import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../configs/api';
import { toast } from 'react-toastify';
// import NotFound from '../404/NotFound';

const AddPhim = () => {
    const [form, setForm] = useState({
        ten_phim: '',
        ten_khac: '',
        mo_ta: '',
        nam_phat_hanh: '',
        thoi_luong: '',
        loai_phim: 'phimle',
        quoc_gia: 'vn',
        links_vietsub: '',
        links_thuyetminh: '',
        banner: null,
        poster: null,
        tinh_trang: '',
        so_tap: '',
    });
    
    const [dsTheLoai, setDsTheLoai] = useState([]);
    const [selectedTheLoai, setSelectedTheLoai] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setForm(prev => ({ ...prev, [name]: files[0] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!form.ten_phim || !form.links_vietsub) {
            alert('Vui lòng nhập tên phim và link vietsub!');
            return;
        }
        const linksVietsubArray = form.links_vietsub.split("\n").map(link => link.trim()).filter(link => link);
        const linksThuyetminhArray = form.links_thuyetminh.split("\n").map(link => link.trim()).filter(link => link);
        const formData = new FormData();
        formData.append('ten_phim', form.ten_phim);
        formData.append('ten_khac', form.ten_khac);
        formData.append('mo_ta', form.mo_ta);
        formData.append('tinh_trang', form.tinh_trang);
        formData.append('so_tap', form.so_tap);
        formData.append('nam_phat_hanh', form.nam_phat_hanh);
        formData.append('thoi_luong', form.thoi_luong);
        formData.append('loai_phim', form.loai_phim);
        formData.append('quoc_gia', form.quoc_gia);
        if (form.banner) {
            formData.append('banner', form.banner);
        }
        if (form.poster) {
            formData.append('poster', form.poster);
        }
        linksVietsubArray.forEach(link => formData.append('links_vietsub', link));
        linksThuyetminhArray.forEach(link => formData.append('links_thuyetminh', link));

        const token = localStorage.getItem("accessToken");
        try {
            await axios.post(`${BASE_URL}/api/import_phim/`, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                }
            });
            toast.success('Thêm phim thành công!');
            // Reset form và file input
            setForm({
                ten_phim: '',
                ten_khac: '',
                mo_ta: '',
                nam_phat_hanh: '',
                thoi_luong: '',
                loai_phim: 'phimle',
                quoc_gia: 'vn',
                links_vietsub: '',
                links_thuyetminh: '',
                banner: null,
                poster: null,
                tinh_trang: '',
                so_tap: '',
            });
            // Reset file input visuals (hơi khó làm chuẩn nếu không dùng useRef)
             e.target.reset(); // Cách đơn giản để reset form, bao gồm cả file input
        } catch (err) {
            console.error(err);
            // Cung cấp thông tin lỗi chi tiết hơn nếu có thể
            const errorMsg = err.response?.data?.message || err.message || 'Có lỗi xảy ra khi import!';
            alert(`❌ ${errorMsg}`);
        }
    };

    // Định nghĩa class chung cho các input để dễ quản lý
    const inputClass = "block w-full bg-gray-700 border border-gray-600 rounded-md py-2 px-3 text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder-gray-400";
    const fileInputClass = "block w-full text-sm text-gray-400 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700 cursor-pointer";
    const labelClass = "block text-sm font-medium text-gray-300 mb-2";

    return (
        <div className="w-full min-h-screen md:p-2">
            <h2 className="text-2xl md:text-3xl text-white mb-6 font-bold">Nhập Dữ Liệu Phim Mới</h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Cột 1 */}
                <div>
                    <div>
                        <label htmlFor="ten_phim" className={labelClass}>Tên Phim (*)</label>
                        <input type="text" id="ten_phim" name="ten_phim" value={form.ten_phim} onChange={handleChange} className={inputClass} required />
                    </div>

                    <div className="mt-4">
                        <label htmlFor="ten_khac" className={labelClass}>Tên Khác</label>
                        <input type="text" id="ten_khac" name="ten_khac" value={form.ten_khac} onChange={handleChange} className={inputClass} />
                    </div>

                    <div className="mt-4">
                        <label htmlFor="mo_ta" className={labelClass}>Mô tả</label>
                        <textarea id="mo_ta" name="mo_ta" rows={4} value={form.mo_ta} onChange={handleChange} className={inputClass}></textarea>
                    </div>

                    <div className="mt-4">
                        <label htmlFor="nam_phat_hanh" className={labelClass}>Năm phát hành</label>
                        <input type="number" id="nam_phat_hanh" name="nam_phat_hanh" value={form.nam_phat_hanh} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 2024"/>
                    </div>

                     <div className="mt-4">
                        <label htmlFor="thoi_luong" className={labelClass}>Thời lượng</label>
                        <input type="text" id="thoi_luong" name="thoi_luong" value={form.thoi_luong} onChange={handleChange} className={inputClass} placeholder="Ví dụ: 90 phút hoặc 120 phút"/>
                    </div>

                    <div className="mt-4">
                         <label htmlFor="banner" className={labelClass}>Banner</label>
                         <input type="file" id="banner" name="banner" accept="image/*" onChange={handleFileChange} className={fileInputClass} />
                     </div>

                     <div className="mt-4">
                         <label htmlFor="poster" className={labelClass}>Poster</label>
                         <input type="file" id="poster" name="poster" accept="image/*" onChange={handleFileChange} className={fileInputClass} />
                     </div>
                </div>

                {/* Cột 2 */}
                <div>
                    <div>
                        <label htmlFor="loai_phim" className={labelClass}>Loại Phim</label>
                        <select id="loai_phim" name="loai_phim" value={form.loai_phim} onChange={handleChange} className={inputClass}>
                            <option value="phimle">Phim Lẻ</option>
                            <option value="phimbo">Phim Bộ</option>
                        </select>
                    </div>

                     <div className="mt-4">
                         <label htmlFor="so_tap" className={labelClass}>Số tập</label>
                         <input type="number" id="so_tap" name="so_tap" value={form.so_tap} onChange={handleChange} className={inputClass} placeholder="Chỉ nhập nếu là Phim Bộ"/>
                     </div>

                     <div className="mt-4">
                         <label htmlFor="tinh_trang" className={labelClass}>Tình trạng</label>
                         <input type="text" id="tinh_trang" name="tinh_trang" value={form.tinh_trang} onChange={handleChange} className={inputClass} placeholder="Ví dụ: Full HD, Tập 5 Vietsub, Hoàn thành"/>
                     </div>


                    <div className="mt-4">
                        <label htmlFor="quoc_gia" className={labelClass}>Quốc Gia</label>
                        <select id="quoc_gia" name="quoc_gia" value={form.quoc_gia} onChange={handleChange} className={inputClass}>
                            {/* Danh sách quốc gia có thể mở rộng hoặc lấy từ API */}
                            {['vn', 'us', 'kr', 'cn', 'jp', 'th', 'in', 'fr', 'uk', 'ru', 'de', 'it', 'es', 'au', 'ca', 'ph', 'id', 'sg', 'my', 'hk', 'other'].map(qg => (
                                <option key={qg} value={qg}>{qg.toUpperCase()}</option>
                            ))}
                        </select>
                    </div>

                    <div className="mt-4">
                        <label htmlFor="links_vietsub" className={labelClass}>Links Vietsub (*)</label>
                        <textarea id="links_vietsub" name="links_vietsub" rows={5} value={form.links_vietsub} onChange={handleChange} className={inputClass} placeholder="Mỗi link một dòng..." required></textarea>
                    </div>

                    <div className="mt-4">
                        <label htmlFor="links_thuyetminh" className={labelClass}>Links Thuyết Minh</label>
                        <textarea id="links_thuyetminh" name="links_thuyetminh" rows={5} value={form.links_thuyetminh} onChange={handleChange} className={inputClass} placeholder="Mỗi link một dòng..."></textarea>
                    </div>
                </div>

                {/* Nút Submit */}
                <div className="md:col-span-2 text-center mt-6">
                    <button type="submit" className="w-full md:w-auto bg-blue-600 text-white px-8 py-3 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 focus:ring-blue-500 font-semibold transition duration-150 ease-in-out">
                        Import Phim
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AddPhim;